import { render } from "./NavigationBarComponent.vue?vue&type=template&id=c0579cbc&scoped=true"
import script from "./NavigationBarComponent.vue?vue&type=script&lang=js"
export * from "./NavigationBarComponent.vue?vue&type=script&lang=js"

import "./NavigationBarComponent.vue?vue&type=style&index=0&id=c0579cbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0579cbc"]])

export default __exports__